import { IgnorableError } from "@ionic/app-scripts/dist/util/errors";
import { DrugSearchTCCDetails } from "./drug-search-tcc-details";

export class DrugSearchCriteria {
  customerSetId: number;
  level: string;
  value: string;
  formularyPackageId: number;
  formularyPackageDate: string;
  reasonNotPricedDisplay: string;
  obsoleteDrugDisplay: string;
  repackagersDisplay: string;
  otcDrugDisplay: string;
  excludedProgramDisplay: string;
  fileEventId: string;
  drugListId: number;
  gcnId: string;
  gcnSequenceNumber: string;
  tierValueCount: string;
  limit: number;
  offset: number;
  selectedLabelName: string;

  planId?: number;

  groupId ?: number;
  tccCategory ?: string;
  tccClass ?: string;
  classBrandOrGeneric ?: string;
  tccDetails : Array<DrugSearchTCCDetails>;
}
